import { PinterestClientPayload } from '@/pages/api/tracking/pinterest/pinterestAPIUtils';

/**
 * Triggers a Pinterest CAPI event by sending the payload to our server-side API route.
 * This function is safe to use on the client-side as no sensitive data is exposed.
 *
 * @param payload The type-safe event payload.
 */
export const triggerPinterestCAPIEvent = async (payload: PinterestClientPayload) => {
	try {
		await fetch('/api/tracking/pinterest', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload),
		});
	} catch (error) {
		console.error('Failed to trigger Pinterest CAPI event:', error);
	}
};
